import { Coordinate } from '@models/coordinate';

export enum DestinationType {
  CallCard = 0,
  Destination = 1,
  DeploymentPoint = 2
}

export class Destination {
  location: Coordinate;
  destinationType: DestinationType;
  destinationId: string;
}
